<template>
	<div class='content'>
		<van-nav-bar
		  title="访问信息"
		  left-arrow
		 />
		<van-list
		  v-model="loading"
		  :finished="finished"
		  finished-text="没有更多了"
		  @load="onLoad"
		>
		<van-cell-group class='box_group'>
			<div v-for="(user,i) in list">
				<div class="box_visit">
					<p>
					    <van-icon name="manager" />
						访问人：{{user.name}}
						<span v-if="hide">{{user.id}}</span>
						
					</p>
					<p><van-icon name="clock" />
						访问时间：{{user.time}}
					</p>
					<p>
						<van-icon name="bars" />
						访问类型：{{user.type}}
					</p>
					<p>
						<van-icon name="comment" />
						处理状态：<span style="color: #009CFF;">{{user.code}}</span>
					</p>
					<p>
						<van-icon name="more" />
						备注：<span>{{user.remarks}}</span>
					</p>
					<p  class="check">
					  
						<span class="check_code">状态查看</span> <van-icon name="arrow" />
					</p>
				</div>
				
			</div>
		</van-cell-group>	
		</van-list>
		
		<van-tabbar v-model="active">
		   <van-tabbar-item icon="home-o"><router-link to="/wx_index" class="router" >我的预约</router-link></van-tabbar-item>
		   <van-tabbar-item icon="search"><router-link to="/wx_visit" class="router activerouter">我的访问</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_center" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { AddressList } from 'vant';

  export default {
  data () {
    return {
    	 hide:false,
    	
    	  active: 1,
	       list: [
	          {
	          id: 1,
	          name:'张氏',
	          time:'2019-12-20 15:20',
	          type:'个人',
	          code:'已通过',
	          remarks:'开会'
	        },
	         {
	          id: 2,
	          name:'张氏',
	          time:'2019-12-20 15:20',
	          type:'个人',
	          code:'已通过',
	          remarks:'开会'
	        },
	         {
	          id: 3,
	          name:'张氏',
	          time:'2019-12-20 15:20',
	          type:'个人',
	          code:'已通过',
	          remarks:'开会'
	        },
	        {
	          id: 4,
	          name:'张氏',
	          time:'2019-12-20 15:20',
	          type:'个人',
	          code:'已通过',
	          remarks:'开会'
	        },
	        {
	          id: 5,
	          name:'张氏',
	          time:'2019-12-20 15:20',
	          type:'个人',
	          code:'已通过',
	          remarks:'开会'
	        },
	        {
	          id: 6,
	          name:'张氏',
	          time:'2019-12-20 15:20',
	          type:'个人',
	          code:'已通过',
	          remarks:'开会'
	        },
	        {
	          id: 7,
	          name:'张氏',
	          time:'2019-12-20 15:20',
	          type:'个人',
	          code:'已通过',
	          remarks:'开会'
	        }
	       ],
	      loading: false,
	      finished: false
     
	    }
    },
    mounted(){
    	
    },
	methods: {
	  onLoad() {
	      // 异步更新数据
	      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
	     
	        // 加载状态结束
	        this.loading = false;
	
	        // 数据全部加载完成
	        this.finished = true;
	       
	    }
	}
}
</script>

<style>
	.router{
		color: #646566;
	}
	.activerouter{
		color: #1989fa;
	}
	.box_visit{
		width: 80%;
		margin-top:10px;
		margin-left: 10%;
		height: 200px;
		margin-bottom: 10px;
		border: 1px solid darkgray;
	}
	.box_visit .van-cell{
		border-color: azure;
	}
	
	.box_visit p{
		width: 100%;
		height: 33px;
		text-align: left;
		line-height: 33px;
		border-bottom: 1px solid gainsboro;
	}
	.box_visit p i {
		color: #00B2AD;
		width: 20px;
		height: 20px;
		font-size: 15px;
		
		margin-left: 10px;
	}
	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	.box_visit .check{
		text-align: right !important;
	}
.box_visit  .check i {
		margin-left: 0px !important;
		margin-right: 8px !important;
		margin-top:10px;
	}
	.check_code{
		display:inline-block;	
		width: 80px;
		height: 33px;
		position: relative;
		top: -2.5px;
		}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatvisitors/wx_visit.vue